import generateQuery from '@/libs/generate-query'
import HttpRequest from './HttpRequest'

class CompanyDepartmentProvider extends HttpRequest {
  findAll () {
    return this.get('/company-department/department/all')
  }

  createGroup (payload) {
    return this.post('/company-department', payload)
  }

  updateGroup (id, payload) {
    return this.patch(`/company-department/${id}`, payload)
  }

  deleteGroup (id) {
    return this.delete(`/company-department/${id}`)
  }

  paginate (page = 1, limit = 10, query) {
    return this.get(`/company-department?page=${page}&limit=${limit}${generateQuery(query)}`)
  }
}

export default CompanyDepartmentProvider
